const type = 'SET_CARD_EDIT_PARAM_SUBMITTING';

const setCardEditParamSubmitting = (data) => ({
  data,
  type,
});

export { type };
export default setCardEditParamSubmitting;
